import { Archive, Bell, Bot, FileCheck, FileSearch, LayoutDashboard, Layers, LucideIcon } from 'lucide-react';

/* 메뉴 정의 — 사이드바와 라우팅이 같은 것을 본다.
 *
 * 한 곳만 고치면 사이드바·라우트가 함께 따라온다.
 *
 * **2026-09-20 에 단계별 메뉴를 걷어냈다.** `검토 대상`·`2 재무계획`·
 * `3 제안서`·`4 수행` 이 각각 메뉴였는데, 같은 건을 단계로 쪼개 놓은 것이라
 * 화면마다 같은 항목이 되풀이됐다. 이제 **프로젝트 메뉴 하나**고 단계는 보드의
 * 칸이다. 메뉴를 셋으로 둔 이유가 「여는 빈도」였는데, 보드는 모든 단계가
 * 한 화면에 있어 그 이유가 없어졌다.
 *
 * 규칙
 *  - 순서는 업무 흐름. 공고에서 시작해 프로젝트로 간다
 *  - 단계 번호를 붙이지 않는다 — 번호는 프로젝트 상세의 흐름표에만 있다
 *  - 못 만든 메뉴는 숨기지 않고 `준비 중` 으로 둔다
 */

export type MenuItem = {
  key: string;
  path: string;
  label: string;
  icon: LucideIcon;
  /** 아직 만들지 않은 화면 */
  soon?: boolean;
  children?: MenuItem[];
};

export const MENU: (MenuItem | { group: string })[] = [
  { key: 'dash', path: '/', label: '대시보드', icon: LayoutDashboard },
  { group: '업무' },
  { key: 'bids', path: '/bids', label: '공고', icon: FileSearch },
  { key: 'projects', path: '/projects', label: '프로젝트', icon: Layers },
  { key: 'archive', path: '/archive', label: '아카이브', icon: Archive },
  { key: 'company-docs', path: '/company-docs', label: '회사서류', icon: FileCheck },
  { group: '설정' },
  { key: 'schedules', path: '/schedules', label: '수집·알림', icon: Bell },
  { key: 'ai', path: '/ai', label: 'AI 관리', icon: Bot },
];

/** 그룹 머리글을 뺀 메뉴 항목 */
export const menuItems = MENU.filter(
  (m): m is MenuItem => !('group' in m),
);

/** 라우팅에 쓸 잎 노드 — 자식이 있으면 자식만 라우트를 갖는다 */
export const menuLeaves: MenuItem[] = menuItems.flatMap((m) =>
  m.children ? m.children : [m],
);

/** 지금 열려 있는 메뉴의 key.
 *
 * 정확히 맞는 것을 먼저 찾고, 없으면 가장 긴 접두사를 쓴다.
 * 그냥 접두사로만 보면 `/bids/review` 가 `/bids`(공고)에도 걸린다. */
export function activeKey(pathname: string): string | undefined {
  const exact = menuLeaves.find((m) => m.path === pathname);
  if (exact) return exact.key;
  return menuLeaves
    .filter((m) => pathname.startsWith(`${m.path}/`))
    .sort((a, b) => b.path.length - a.path.length)[0]?.key;
}
